<template>
  <v-layout row align-center pl-3 class="mt-0">
    <v-flex shrink>
      <div>{{dataTitle}}</div>
    </v-flex>
    <v-spacer></v-spacer>
    <v-flex shrink>
      <span v-if="isReload">
        <v-btn flat icon @click="reload">
          <v-icon>cached</v-icon>
        </v-btn>
      </span>
      <span v-if="isDownload">
        <v-btn flat icon @click="download">
          <v-icon>get_app</v-icon>
        </v-btn>
      </span>
    </v-flex>
  </v-layout>
</template>

<script>
import { EventBus } from '@/services/event-bus'

export default {
  props: {
    dataTitle: {
      type: String
    },
    isReload: {
      type: Boolean,
      default: true
    },
    isDownload: {
      type: Boolean,
      default: true
    },
    isEmit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    reload() {
      if (this.isEmit) {
        this.$emit('reload:report')
      } else {
        EventBus.$emit('reload:report')
      }
    },
    download() {
      if (this.isEmit) {
        this.$emit('download:report')
      } else {
        EventBus.$emit('download:report')
      }
    }
  }
}
</script>
